export const BreakPoint = {
    xl: 'xl',
    lg: 'lg',
    md: 'md',
    sm: 'sm',
    xs: 'xs',
};

export const BreakPoints = {
    [BreakPoint.xl]: 1920,
    [BreakPoint.lg]: 1440,
    [BreakPoint.md]: 1024,
    [BreakPoint.sm]: 768,
    [BreakPoint.xs]: 360,
};

export const pickBreakpoint = (arg = BreakPoint.xs) => {
    return BreakPoints[arg];
};
